import { legacyEmployments } from './legacyEmployments';
import { salaryReviewAssessments } from './salaryReviewAssessments';
import { salaryReviewEmployments } from './salaryReviewEmployments';

export const managers = {
    legacyEmployments,
    salaryReviewAssessments,
    salaryReviewEmployments,
};
